import React from 'react';
import '../../styles/footer.scss';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import Logo from '../../assets/logo7.png';

const Footer = () => {
  return (
    <footer className="footer__section footer__bg">
      <div className="container-fluid container">
        <div className="main__footer">
          <div className="row">
            {/* About Us */}
            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <div className="footer__widget--inner">
                  <Navbar.Brand
                    as={Link}
                    to="/"
                    className="logo d-flex align-items-center fw-bold mb-3"
                  >
                    <img src={Logo} alt="logo" className="logo" />
                    {/* <span className="logo-red">ARTI</span>
                    <span className="logo-black">ZA</span> */}
                  </Navbar.Brand>
                  <p className="footer__widget--desc">
                    Empowering Kenya’s Makers. Inspiring the World.
                  </p>
                  <p>A digital platform that connects, dignifies, and showcases Kenya’s skilled artisans — powered by technology, storytelling, and trust.</p>

                  <div className="footer__social">
                    <ul className="social__shear d-flex">
                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/"
                        >
                          <FaFacebookF />
                          <span className="visually-hidden">Facebook</span>
                        </a>
                      </li>

                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://twitter.com/"
                        >
                          <FaXTwitter />
                          <span className="visually-hidden">Twitter</span>
                        </a>
                      </li>

                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/"
                        >
                          <FaInstagram />
                          <span className="visually-hidden">Instagram</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title">Quick Links</h2>
                <ul className="footer__widget--menu footer__widget--inner">
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/about">
                      About Us
                    </a>
                  </li>
                  {/* <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/wishlist">
                      Wishlist
                    </a>
                  </li> */}
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/contact">
                      Contact Us
                    </a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a
                      className="footer__widget--menu__text"
                      href="/privacy-policy"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a
                      className="footer__widget--menu__text"
                      href="/terms-and-conditions"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/faq">
                      Frequently
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Account Info */}
            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title">Account Info</h2>
                <ul className="footer__widget--menu footer__widget--inner">
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/login">
                      My Account
                    </a>
                  </li>
                  {/* <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/cart">
                      Shopping Cart
                    </a>
                  </li> */}
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/login">
                      Login
                    </a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/register">
                      Register
                    </a>
                  </li>
                  {/* <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/checkout">
                      Checkout
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title">Newsletter</h2>
                <div className="footer__newsletter footer__widget--inner">
                  <p className="footer__newsletter--desc">
                    Get updates by subscribing to our weekly newsletter
                  </p>
                  <form
                    className="newsletter__subscribe--form__style position__relative"
                    action="#"
                  >
                    <label>
                      <input
                        className="footer__newsletter--input newsletter__subscribe--input"
                        placeholder="Enter your email address"
                        type="email"
                      />
                    </label>
                    <button
                      className="footer__newsletter--button newsletter__subscribe--button primary__btn"
                      type="submit"
                    >
                      Subscribe
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom d-flex justify-content-between align-items-center">
          <p className="copyright__content m-0">
            Copyright © {new Date().getFullYear()}{' '}
            <a className="copyright__content--link" href="/">
              ARTIZA
            </a>{' '}
            . All Rights Reserved. Design By Gachoka Stephen
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
